import { IOptions } from '../components';
import { GetAnticipationResult } from '../services/hooks/useAntecipacao';
import { CnpjMask } from './CnpjMask';
import { CpfMask } from './CpfMask';

const listEstablishmentsOptionsToSet = (data: GetAnticipationResult[]) => {
  const establishmentsAvailable = new Set();
  data.forEach((loja) => establishmentsAvailable.add(loja.estabDocto));
  const arrayEstablishmentsAvailable = Array.from(establishmentsAvailable);

  const optionsToSet: IOptions[] = arrayEstablishmentsAvailable.map((each) => {
    const toList = data.find((loja) => loja.estabDocto === each);
    if (toList?.estabFantasia) {
      return {
        id: toList.estabDocto,
        value: `${
          toList?.estabDocto && toList?.estabDocto?.length > 11
            ? CnpjMask(toList?.estabDocto)
            : CpfMask(toList?.estabDocto)
        } - ${toList.estabFantasia}`,
      };
    } else if (toList?.estabDocto) {
      return { id: toList?.estabDocto, value: toList?.estabDocto };
    }
    return { id: each, value: each } as IOptions;
  });

  return optionsToSet;
};

export { listEstablishmentsOptionsToSet };
